import { render, staticRenderFns } from "./PreferenceCateg.vue?vue&type=template&id=75f52d54&scoped=true"
import script from "./PreferenceCateg.vue?vue&type=script&lang=js"
export * from "./PreferenceCateg.vue?vue&type=script&lang=js"
import style0 from "./PreferenceCateg.vue?vue&type=style&index=0&id=75f52d54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f52d54",
  null
  
)

export default component.exports